// extracted by mini-css-extract-plugin
export var sliderRange = "_oz-2";
export var sliderRoot = "_oz-0";
export var sliderThumb = "_oz-3";
export var sliderTrack = "_oz-1";